import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface I18nText {
  ko?: string;
  en?: string;
  vi?: string;
}

export interface I18nStringArray {
  ko?: string[];
  en?: string[];
  vi?: string[];
}

export interface Partner {
  id: number;
  name: string;
  country: 'Korea' | 'Vietnam';
  initials: string;
  sector: string;
  sector_i18n?: I18nText;
  color: string;
  logo_url?: string;
  sort_order: number;
  created_at?: string;
}

export interface Service {
  id: number;
  icon: string;
  title: string;
  title_i18n?: I18nText;
  short_desc: string;
  short_desc_i18n?: I18nText;
  description: string;
  description_i18n?: I18nText;
  features: string[];
  features_i18n?: I18nStringArray;
  image_url: string;
  sort_order: number;
  created_at?: string;
}

export interface TradeBrand {
  id: number;
  direction: 'import' | 'export';
  name: string;
  tagline: string;
  tagline_i18n?: I18nText;
  origin: string;
  origin_flag: string;
  destination: string;
  destination_flag: string;
  category: string;
  category_i18n?: I18nText;
  description: string;
  description_i18n?: I18nText;
  features: string[];
  features_i18n?: I18nStringArray;
  image_url: string;
  icon: string;
  sort_order: number;
  created_at?: string;
}

export interface AboutSection {
  id: number;
  section_key: string;
  content_i18n: Record<string, Record<string, string>>;
  created_at?: string;
}

export interface NewsPost {
  id: number;
  slug: string;
  title_i18n: I18nText;
  summary_i18n: I18nText;
  content_i18n: I18nText;
  cover_image_url: string;
  tags: string[];
  author: string;
  is_published: boolean;
  published_at: string | null;
  sort_order: number;
  created_at?: string;
}
